import React from 'react'

function Projects(props) {
  return (
    <>
    
    <div id='di3'style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`,color:`${props.mode==='light'?'white':'rgb(83, 80, 80)'}`}}>

       <h1 className="projectHead">
            <span className="wordSkill" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`, color:`${props.mode==='light'?'white':'rgb(11, 117, 117)'}`}}>PROJECTS </span>
            </h1>

       <div id="projectContainer" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`}}>


        <div className="projectInnerBox" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`,color:`${props.mode==='light'?'white':'rgb(83, 80, 80)'}`}}>
          <div className="projectImgDiv">
          <img className='projectImg' src="https://cdn.dribbble.com/users/45617/screenshots/14721032/media/7cf36da5448d8d768ee11e72d5975a31.png?compress=1&resize=400x300" alt="" />
          </div>
          <div className="projectDetails">
          <h3 className='appleTitle'>Apple Clone</h3>
          <p>It is an amarican electronics and software company. It deals in products like mobile, tv,ipods,smart watch.
            Providing the facilty to purchase online/online stores.
          </p>
          <h3 className='appleTitle'>Tech Used</h3>
          <p>html,css,javascript</p>
          <h3> Functionality</h3>
          <p>header,footer,login,signup,landing page, payment page</p>
          </div>
        </div>

        <div className="projectInnerBox">
        <div className="projectImgDiv">
          <img className='projectImg' src="https://techengage.com/wp-content/uploads/2018/11/best-news-apps-android-ios.jpg" alt="" />
          </div>
          <div className="projectDetails">
          <h3 className='appleTitle'>News Bharat</h3>
          <p>News Bharat is a personalized news aggrigator that organizes and highlights what's 
            happening in the world so that you can quickly catch up and discover more about the stories that matter to you. 
          </p>
          <h3 className='appleTitle'>Tech Used</h3>
          <p>html,css,javascript,react,bootstrap</p>
          <h3> Functionality</h3>
          <p>landing page, search bar for news category, login,signup</p>
          </div>
        </div>

        <div className="projectInnerBox">
        <div className="projectImgDiv">
          <img className='projectImg' src="https://techengage.com/wp-content/uploads/2018/11/best-news-apps-android-ios.jpg" alt="" />
          </div>
        
          <div className="projectDetails">
          <h3 className='appleTitle'>YouTube clone</h3>
          <p>This is a clone of you tube, with some of the functionalities of youTube original app. 
          </p>
          <h3 className='appleTitle' >Tech Used</h3>
          <p>html,css,javascript,localstorage</p>
          <h3> Functionality</h3>
          <p>landing page,playing full screen video,login,signup</p>

          <a target='_blank' href="https://singular-croissant-268965.netlify.app">
          <button className='website' style={{float:"right", marginBottom:"3%",borderRadius:"10px", padding:"1% 1%"}} >see website</button>
          </a>
          </div>
        </div>
       </div>

       <div className="blank"></div>


    </div>
    </>
  )
}

export default Projects